.category {
  background-color: var(--pgm-sys-color-surface);
  border-radius: 16px;
  box-shadow: var(--pgm-sys-elevation-level1);
  box-sizing: border-box;
}

.trigger {
  align-items: center;
  background: none;
  border: 0;
  border-radius: 16px;
  cursor: pointer;
  display: flex;
  gap: var(--pgm-sys-spacing-6);
  justify-content: space-between;
  padding: var(--pgm-sys-spacing-6);
  text-align: left;
  width: 100%;
}

.trigger:hover {
  background-color: var(--pgm-sys-color-surface-container-low);
}

.trigger:focus-visible {
  outline: 3px solid var(--pgm-sys-color-secondary);
  outline-offset: -3px;
}

.name {
  color: var(--pgm-sys-color-secondary);
  min-width: 0;
}

.chevron {
  color: var(--pgm-sys-color-on-surface-variant);
  flex-shrink: 0;
  font-size: 24px;
  line-height: 24px;
}

.questions {
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0 var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-4);
}

.question {
  border-top: 1px solid var(--pgm-sys-color-outline-variant);
}

.questionTrigger {
  align-items: center;
  background: none;
  border: 0;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  gap: var(--pgm-sys-spacing-4);
  justify-content: space-between;
  padding: var(--pgm-sys-spacing-4) 0;
  text-align: left;
  width: 100%;
}

.questionTrigger:hover .questionText {
  color: var(--pgm-sys-color-secondary);
}

.questionTrigger:focus-visible {
  outline: 3px solid var(--pgm-sys-color-secondary);
  outline-offset: -3px;
}

.questionText {
  color: var(--pgm-sys-color-on-surface);
  min-width: 0;
}

.answer {
  color: var(--pgm-sys-color-on-surface-variant);
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-4);
  padding: 0 0 var(--pgm-sys-spacing-4);
}

.answer p {
  margin: 0;
}

.answer a {
  color: var(--pgm-sys-color-secondary);
  text-decoration: underline;
}

.answer a:hover,
.answer a:focus {
  color: color-mix(
    in srgb,
    var(--pgm-sys-color-on-surface) 52%,
    var(--pgm-sys-color-secondary)
  );
  text-decoration: underline;
}

@media (max-width: 599.98px) {
  .trigger {
    padding: var(--pgm-sys-spacing-4);
  }

  .questions {
    padding: 0 var(--pgm-sys-spacing-4) var(--pgm-sys-spacing-2);
  }
}
